(ns machtfit.product-form.resale-info
  (:require [clojure.set :refer [rename-keys]]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.product-form.how-much :as how-much]
            [machtfit.product-form.section :refer [show-next-section]]
            [re-frame.core :as rf]))

(rf/reg-event-db ::set-article-number
  (fn [db [_ new-article-number]]
    (-> db
        (assoc-in [:product :resale-info :article-number] new-article-number)
        (assoc-in [:ui :last-focused-config-section] nil))))

(defn- article-number []
  [:div.col.s12
   [widgets/block-input
    {:id "resale-article-number"
     :label-text "Artikelnummer für Reselling"
     :value @(rf/subscribe [:get [:product :resale-info :article-number]])
     :on-change #(rf/dispatch [::set-article-number %])
     :block-style {:width "100%"}
     :style {:width "100%"}}]])

(defn- cost-price []
  [:div.row {:style {:margin-left "0.2rem"
                     :margin-bottom 0}}
   [:div.col {:style {:display "flex"
                      :align-items "center"
                      :justify-content "center"
                      :margin-top "1rem"
                      :width "20%"}}
    [widgets/amount-input
     {:id "resale-cost-price"
      :label-text "Einkaufspreis (netto)"
      :value @(rf/subscribe [:get [:product :resale-info :cost-price]])
      :input-style {:font-size "2rem" :text-align "right"}
      :handler #(rf/dispatch [::how-much/handle-amount [:product :resale-info :cost-price] %])}]
    [:span {:style {:font-size "1rem"
                    :margin-left "1rem"}}
     "€"]]])

(defn- resale-info []
  (let [resale-product? @(rf/subscribe [:get [:product :resale-info :resale-product?]])
        resale-suppliers (map #(rename-keys % {:name :text}) @(rf/subscribe [:get [:ui :resale-suppliers]]))
        resale-supplier' @(rf/subscribe [:get [:product :resale-info :resale-supplier]])
        resale-supplier-for-select (when resale-supplier'
                                     (rename-keys resale-supplier' {:name :text}))]
    [:div.col.s12.form-container
     [:input.filled-in {:type "checkbox"
                        :id "resale-product"
                        :checked @(rf/subscribe [:get [:product :resale-info :resale-product?]])
                        :on-change #(rf/dispatch [:toggle [:product :resale-info :resale-product?]])}]
     [:label.black-text {:for "resale-product"
                         :style {:height "auto"
                                 :line-height "normal"}}
      "Wiederverkaufsprodukt?"]
     (when resale-product?
       [:<>
        [article-number]
        [cost-price]
        (when (seq resale-suppliers)
          [widgets/block-select {:id "resale-supplier"
                                 :label-text [:span "Wiederverkäufer"]
                                 :choices resale-suppliers
                                 :placeholder "--------"
                                 :shown-entries 20
                                 :value resale-supplier-for-select
                                 :on-save #(let [new-resale-supplier (when % (rename-keys % {:text :name}))]
                                             (rf/dispatch [:set-path [:product :resale-info :resale-supplier] new-resale-supplier]))}])])]))

(defn section-resale-info []
  [widgets/section
   {:anchor "resale-info"
    :title "Resell"
    :content [:div
              [resale-info]
              [show-next-section :resale-info]]}])
